import { VueSlideToggle } from "vue-slide-toggle";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "ComsobaseInfoActions",
    props: {},
    emits: [],
    components: {
      VueSlideToggle,
    },
    setup() {},
    data() {
        return {
          openedItems: [],
          showMenu: false,
          playingVideo: [],
        }
    },
    async created() {
      const lessonId = this.$route.params.lessonId;
      await this.getLessonById(lessonId)
      this.showMenu = window.innerWidth > 768
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar",
        lesson: "cosmobase/lesson"
      }),
      currentBlock() {
        const lessonId = this.$route.params.lessonId;
        const blocks = this.content.blocks.data
        const found = blocks.find(item => item.lessons.data.some(lesson => lesson.id === lessonId))
        return found
      },
      prevVideoId() {
        const blocks = this.content.blocks.data
        const lessonId = Number(this.$route.params.lessonId);
        const found = blocks.find(item => item.lessons.data.some(lesson => lesson.id === lessonId))
        const blockIndex = blocks.findIndex(item => item.lessons.data.some(lesson => lesson.id === lessonId))
        const currentLessonIndex = found.lessons.data.findIndex(item => item.id === lessonId)
        const prev = found.lessons.data[currentLessonIndex - 1]
        if (prev) {
          return prev.id;
        } else {
          const prevBlock = blocks[blockIndex - 1]
          if (prevBlock) {
            return prevBlock.lessons.data[prevBlock.lessons.data.length - 1].id;
          }
          return null
        }
      },
      nextVideoId() {
        const blocks = this.content.blocks.data
        const lessonId = Number(this.$route.params.lessonId);
        const found = blocks.find(item => item.lessons.data.some(lesson => lesson.id === lessonId))
        const blockIndex = blocks.findIndex(item => item.lessons.data.some(lesson => lesson.id === lessonId))
        const currentLessonIndex = found.lessons.data.findIndex(item => item.id === lessonId)
        const next = found.lessons.data[currentLessonIndex + 1]
        if (next) {
          return next.id;
        } else {
          const nextBlock = blocks[blockIndex + 1]
          if (nextBlock) {
            return nextBlock.lessons.data[0].id;
          }
          return null
        }
      },
    },
    methods: {
      ...mapActions({
        getLessonById: "cosmobase/GET_LESSON_BY_ID",
        sendCompleteLesson: "cosmobase/SEND_COMPLETE_LESSON_VIDEO",
      }),
      ...mapMutations({
        changeCosmoBaseSecondFormPopup: "popups/CHANGE_COSMOBASE_SECOND_FORM_POPUP",
        changeCosmoBaseReviewPopup: "popups/CHANGE_COSMOBASE_REVIEW_POPUP",
      }),
      playVideo(videoID) {
        const ref = this.$refs['video-' + videoID]
        if (ref) ref[0].play();
        this.playingVideo.push(videoID)
      },
      videoPlaying(videoID) {
        return this.playingVideo.includes(videoID)
      },
      checkNearEnd(videoId, event) {
        const video = event.target
        if (video.duration - video.currentTime <= 60) {
          if (!video._sentComplete) {
            video._sentComplete = true
            this.sendCompleteEvent(videoId, this.$route.params.id)
          }
        }
      },
      storeCosmobaseReviewModalID(id) {
        let ids = JSON.parse(localStorage.getItem("RevisedCosmobaseReviewModalID") || "[]")
        if (!ids.includes(id)) {
          ids.push(id)
          localStorage.setItem("RevisedCosmobaseReviewModalID", JSON.stringify(ids))
        }
      },
      hasCosmobaseReviewModalID(id) {
        let ids = JSON.parse(localStorage.getItem("RevisedCosmobaseReviewModalID") || "[]")
        return ids.includes(id)
      },
      async sendCompleteEvent(videoId, lessonId) {
        const response = await this.sendCompleteLesson(videoId);
        if (response > 30 && response < 40 && !this.hasCosmobaseReviewModalID(lessonId)) {
          this.storeCosmobaseReviewModalID(lessonId)
          this.changeCosmoBaseReviewPopup(true)
        }
        const videoIndex = this.playingVideo.indexOf(videoId)
        this.playingVideo.splice(videoIndex, 1)
      },
      isItemOpened(id) {
        return this.openedItems.includes(id);
      },
      toggleItem(id) {
        const index = this.openedItems.indexOf(id);
        if (index >= 0) {
          this.openedItems.splice(index, 1);
        } else {
          this.openedItems.push(id);
        }
      }
    }
}
